
<block-ui>
	<div class="module-bar">
		<div class="_inner">
			<button mat-icon-button (click)="dialogRef.close()">
				<mat-icon>{{appService.backIcon}}</mat-icon>
			</button>
			<span class="title flex-grow-1">{{'my_wallet' | translate}}</span>
		</div>
	</div>


	<div class="module-content" style="background: #F2F4F7;">
		<!--<div class="generic-desc">{{'my_wallet_description' | translate}}</div>-->

		<div class="accordion-container" *ngIf="!loading">
			<mat-accordion>
				<mat-expansion-panel class="no-pad" [expanded]="step === 'general'" (opened)="step = 'general'">
					<mat-expansion-panel-header>
						<mat-panel-title class="font-bold">{{appService.translate('my_wallet')}}</mat-panel-title>
					</mat-expansion-panel-header>

					<div  *ngIf="userDetails.wallet?.payments?.length">
						<div class="text-far">
							<div style="position:relative;opacity: 0.5; font-size:12px; font-weight:600; padding:0 16px; top:-15px">{{'default' | translate}}</div>
						</div>
						<div>
							<div class="py-2 d-flex justify-content-start align-items-center border-top" *ngFor="let payment of userDetails.wallet.payments">
								<button type="button" mat-icon-button (click)="deletePM(payment, $event);">
									<mat-icon>delete</mat-icon>
								</button>

								<div class="text-md pl-2 no-wrap">
									<div class="inline">{{ payment.paymentType == 'adyen' ? payment.issuer : ('PMS.' + payment.paymentType | translate) }}: </div>
									{{payment.displayPan}}
								</div>
								<div class="text-xs pl-2" *ngIf="['creditCard', 'creditGuard'].includes(payment.paymentType)">
									{{payment | paymentExp}}
								</div>
								<i class="px-1 text-xs pl-2 text-truncate flex-grow-1">
									{{payment.comment}}
								</i>

								<div class="px-1">
									<mat-radio-button [checked]="payment.isDefault" (change)="pmDefaultChanged(payment);" class="m-0"></mat-radio-button>
								</div>
							</div>
						</div>
					</div>


					@if (paymentMethods.length == 1 || !userDetails.wallet?.payments?.length) {
						@if (!userDetails.wallet?.payments?.length) {
							<div class="text-center py-3 font-weight-bolder text-sm">
								{{ 'MESSAGES.NO_PMS_FOUND' | translate }}
							</div>
						}
						<hr>
						<div class="text-center mt-3 pb-4">
							<button type="button" style="height: 50px" mat-raised-button color="accent"
									class="rounded" (click)="addSinglePM()">
								{{ 'add_pm'  | translate }}
							</button>
						</div>
					}


				</mat-expansion-panel>

				@if (paymentMethods.length > 1) {
					<mat-expansion-panel [expanded]="step === 'addpm'" (opened)="step = 'addpm'">
						<mat-expansion-panel-header>
							<mat-panel-title class="font-bold">{{ 'add_pm' | translate }}</mat-panel-title>
						</mat-expansion-panel-header>
						<form (ngSubmit)="addPM()" #addPMForm="ngForm">
							<mat-form-field appearance="outline">
								<mat-select [(value)]="ccinfo.paymentType" (selectionChange)="paymentMethodChanged()"
											placeholder="{{'credit_type' | translate}}" required>
									<mat-option *ngFor="let pm of paymentMethods"
												[value]="pm">{{ 'PMS.' + pm | translate }}
									</mat-option>
								</mat-select>
							</mat-form-field>
							<div [ngSwitch]="ccinfo.paymentType" class="form-condensed">
								<div *ngSwitchCase="'Cibus'">
									<mat-form-field appearance="outline">
										<input [(ngModel)]="ccinfo.pan" name="cardnumber" id="cardNumber" matInput
											   placeholder="{{'credit_card_number' | translate}}" type="tel" required
											   pattern="[0-9]*">
									</mat-form-field>
								</div>
								<div *ngSwitchCase="'10bis'">
									<mat-form-field appearance="outline">
										<input [(ngModel)]="ccinfo.pan" name="cardnumber" id="cardNumber" matInput
											   placeholder="{{'credit_card_number' | translate}}" type="tel" required
											   pattern="[0-9]*">
									</mat-form-field>
								</div>

								<mat-form-field appearance="outline">
									<input [(ngModel)]="ccinfo.comment" name="comment" matInput
										   placeholder="{{'comments' | translate}}">
								</mat-form-field>

							</div>
							<div class="text-far" *ngIf="ccinfo.paymentType">
								<button type="submit" mat-raised-button color="accent" class="rounded"
										[disabled]="!addPMForm.valid">
									{{ 'add_pm'  | translate }}
								</button>
							</div>
						</form>
					</mat-expansion-panel>
				}
			</mat-accordion>
		</div>
	</div>
</block-ui>
